import { render, staticRenderFns } from "./ScreenBill.vue?vue&type=template&id=83ece1ec&scoped=true"
import script from "./ScreenBill.vue?vue&type=script&lang=js"
export * from "./ScreenBill.vue?vue&type=script&lang=js"
import style0 from "./ScreenBill.vue?vue&type=style&index=0&id=83ece1ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ece1ec",
  null
  
)

export default component.exports